/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const physicalInfrastructureEnumsAffectedRedundancyLevelOptionEnum = {
    NPlus1: 'NPlus1',
    V2N: 'V2N',
    SinglePointOfFailure: 'SinglePointOfFailure',
    Other: 'Other',
} as const;

export type PhysicalInfrastructureEnumsAffectedRedundancyLevelOptionEnumKey =
    (typeof physicalInfrastructureEnumsAffectedRedundancyLevelOptionEnum)[keyof typeof physicalInfrastructureEnumsAffectedRedundancyLevelOptionEnum];

export type PhysicalInfrastructureEnumsAffectedRedundancyLevelOption =
    PhysicalInfrastructureEnumsAffectedRedundancyLevelOptionEnumKey;
